import $ from 'jquery';

class GoogleMapsBlocker {
    constructor({ cookieControl }) {
        this.cookieControl = cookieControl;
    }

    blockIfNotAllowed() {
        const maps = $('.cc-map-embed-iframe');
        if (this.cookieControl.isGoogleMapsAllowed()) {
            $.each(maps, (key, map) => {
                $(map).attr('src', $(map).data('src'));
                $(map).css('display', 'block');
            });
        } else {
            $('.cc-map-embed-placeholder').css('display', 'flex');
        }
    }
}

export default GoogleMapsBlocker;



/** WEBPACK FOOTER **
 ** ./webserver/document_root/s/js/web/modules/cookieSettings/featureBlockers/GoogleMapsBlocker.esnext.js
 **/